module.exports = __webpack_public_path__ + "img/install-app-3.c3006da4.jpg";